import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { proposalMutationScopeId } from '@/api/mutations/proposals/proposalMutationScope';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';
import {
  UpdateProposalGroupInput,
  UpdateProposalGroupMutation,
} from '@/gql/graphql';

const UPDATE_PROPOSAL_GROUP_MUTATION = graphql(`
  mutation UpdateProposalGroup($input: UpdateProposalGroupInput!) {
    updateProposalGroup(input: $input) {
      id
    }
  }
`);

const useUpdateProposalGroup = (args?: {
  proposalId?: string;
  options?: UseMutationOptions<
    UpdateProposalGroupMutation,
    unknown,
    UpdateProposalGroupInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};

  return useMutation({
    mutationFn: (input: UpdateProposalGroupInput) => {
      return gqlClient.request(UPDATE_PROPOSAL_GROUP_MUTATION, { input });
    },
    scope: args?.proposalId
      ? { id: proposalMutationScopeId(args.proposalId) }
      : undefined,
    onSuccess: (data, variables, context) => {
      if (args?.proposalId) {
        void queryClient.invalidateQueries({
          queryKey: proposalKeys.proposal(args.proposalId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useUpdateProposalGroup;
